import type { SiteName } from '@seek/melways-sites';
import { useTranslations } from '@vocab/react';
import { Box } from 'braid-design-system';
import { vars } from 'braid-design-system/css';

import translations from './.vocab';
import { JobAdPlanHeader } from './JobAdPlanHeader';
import { JobAdPlanInfo } from './JobAdPlanInfo';
import { jobAdFeatureChartData } from './chartData';

export const JobAdFeatureChart = ({
  embed,
  site,
}: {
  embed?: boolean;
  site: SiteName;
}) => {
  const { t } = useTranslations(translations);
  const data = jobAdFeatureChartData(site, t);

  return (
    <Box
      paddingY={embed ? 'small' : 'medium'}
      paddingX={embed ? 'xsmall' : { mobile: 'xsmall', desktop: 'medium' }}
      background={embed ? 'brandAccentSoft' : undefined}
      borderRadius={embed ? 'xlarge' : 'standard'}
    >
      <Box
        style={{
          maskImage: `linear-gradient(90deg, transparent 0%, white calc(0% + ${vars.space.xsmall}) ,white calc(100% - ${vars.space.xsmall}), transparent 100%)`,
          maskPosition: 'right',
          maskRepeat: 'no-repeat',
          overflowX: 'scroll',
        }}
      >
        <JobAdPlanHeader embed={embed} data={data} />
        <JobAdPlanInfo embed={embed} data={data} />
      </Box>
    </Box>
  );
};
